import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      {/* HERO */}
      <section id="hero-top" className="hero-two">
        <div className="container">
          <div className="row">

            <div className="col-lg-7 hero-2-col">
              <div className="hero-left-content">

                <h1 className="hero-title">
                  121 Bharat Business <span>Tycoon Chamber</span>
                </h1>

                <h3>
                  A LIFETIME OPPORTUNITY AN EVENT TO REMEMBER
                </h3>

                <br />

                <p>RELATIONSHIP CONCLAVE</p>

                <Link to="/about" className="btn-m4">
                  About Us
                </Link>

              </div>
            </div>

            <div className="col-lg-5 hero-2-col">
              <div className="hero-images">
                <img
                  src="/assets/img/h2-head.png"
                  alt="banner"
                />
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* SERVICES */}
      <section id="services-area" className="services-two pt-50">
        <div className="container">

          <div className="row">
            <div className="col-lg-12">
              <div className="section-content text-center">

                <h2 className="section-title">
                  Why 121 Bharat Business Tycoon Chamber?
                </h2>

                <div className="section-border">
                  <span></span>
                </div>

              </div>
            </div>
          </div>


          <div className="row pt-35">

            <div className="col-lg-3 col-md-6">
              <div className="services-item">

                <img
                  src="/assets/img/website-icon.png"
                  alt="Elite Relation"
                />

                <h3>Elite Relation</h3>

                <p>
                  India's top business leaders under one roof
                </p>

                <br />
                <br />

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="services-item">

                <img
                  src="/assets/img/seo-icon.png"
                  alt="Cross-Industry Collaboration"
                />

                <h3>Cross-Industry Collaboration</h3>

                <p>
                  Unlimited opportunities across sector
                </p>

                <br />

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="services-item">

                <img
                  src="/assets/img/market-icon.png"
                  alt="Resource Sharing"
                />

                <h3>Resource Sharing</h3>

                <p>
                  Members support with contacts, Branding of your
                  product & Social Media Manegment
                </p>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="services-item">

                <img
                  src="/assets/img/app-icon.png"
                  alt="Trusted Ecosystem"
                />

                <h3>Trusted Ecosystem</h3>

                <p>
                  Sustainable business growth platform
                </p>

                <br />
                <br />
                <br />

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ABOUT */}
      <section id="about-us" className="about-two pt-130 pb-50">
        <div className="container">

          <div className="row">

            <div className="col-lg-4">
              <div className="about-img">

                <img
                  src="/assets/img/amit-kumar.jpg"
                  alt="Amit Kumar"
                />

                <br />
                <br />

                <h3 className="text-center">
                  Amit Kumar
                </h3>

                <h5 className="text-center">
                  Founder & CMD 121 BBTC
                </h5>

              </div>
            </div>


            <div className="col-lg-8">
              <div className="about-content">

                <div className="section-content">

                  <h3>About Us</h3>

                  <h2 className="section-title">
                    121 Bharat Business Tycoon Chamber
                  </h2>

                  <div className="section-border">
                    <span></span>
                  </div>

                </div>


                <div className="about-text">

                  <h3>Concept & Vision</h3>

                  <ul className="home-three-about-list">

                    <li>
                      Exclusive Business Club: Bharat Business Tycoon
                      Chamber (BBTC) is an exclusive business relationship
                      club of 121 leading entrepreneurs and business
                      leaders from across India.
                    </li>

                    <li>
                      Main objective: The platform is designed to foster
                      investments, startups and growth opportunities as
                      well as build a foundation for strong collaboration
                      for national economic progress.
                    </li>

                  </ul>

                </div>


                <Link to="/about" className="btn-m3">
                  Read More
                </Link>

              </div>
            </div>

          </div>
        </div>
      </section>

    </>
  );
}

export default Home;